const webLink = 'http://www.725-contact.com';

export { webLink };
